module.exports = [
    {
        "label": "A customer visits the website for first time in 30 days",
        "value": "A customer visits the website for first time in 30 days"
    },
    {
        "label": "Customer returns to website within 5 days",
        "value": "Customer returns to website within 5 days"
    },
    {
        "label": "Customer returns to website within 14 days",
        "value": "Customer returns to website within 14 days"
    },
    {
        "label": "Customer returns to website within 30 days",
        "value": "Customer returns to website within 30 days"
    },
    {
        "label": "Topic customer had a conversation about",
        "value": "Topic customer had a conversation about"
    },
    {
        "label": "Customer had a chat with agent",
        "value": "Customer had a chat with agent"
    },
    {
        "label": "Customer left a message",
        "value": "Customer left a message"
    },
    {
        "label": "Chatbot couldn't answer the customer",
        "value": "Chatbot couldn't answer the customer"
    },
    {
        "label": "Customer's country",
        "value": "Customer's country"
    },
    {
        "label": "Customer's preferred language",
        "value": "Customer's preferred language"
    },
    {
        "label": "Customer's device (Desktop, Mobile)",
        "value": "Customer's device (Desktop, Mobile)"
    },
    {
        "label": "Recommender choices made by the customer",
        "value": "Recommender choices made by the customer"
    }
]